import React, { useCallback } from "react";

import Widget from "2g-widget";
import Form, { ActionButton } from "2g-form";
import Buttons, { ButtonsSet } from "2g-buttons";

import { PATHS } from "b2b/constants";
import { useRedirect } from "b2b/hooks";
import useFixniPozadavkyBoxError from "b2b/components/fixni-pozadavky-box/useFixniPozadavkyBoxError";
import FixniPozadavkyBoxErrorContent from "b2b/components/fixni-pozadavky-box/FixniPozadavkyBoxErrorContent";
import useMessages from "./i18n/useMessages";
import { FORM_REZERVACE_VYTVORENI_MODULE_KEY } from "./RezervaceVytvoreniForm";
import RezervaceVytvoreniProjekt from "./RezervaceVytvoreniProjekt";
import useRezervaceVytvoreniFormInitializer from "./hooks/useRezervaceVytvoreniFormInitializer";

export function RezervaceVytvoreniRychlaWidget() {
  useRezervaceVytvoreniFormInitializer();
  const { rychlaWidgetTitle, rychlaWidgetSubmint } = useMessages();
  const fixniPozadavkyBoxError = useFixniPozadavkyBoxError({
    moduleKey: FORM_REZERVACE_VYTVORENI_MODULE_KEY
  });
  const redirect = useRedirect();
  const redirectToVytvoreni = useCallback(() => {
    redirect(PATHS.REZERVACE.VYTVORENI);
  }, [redirect]);

  return (
    <Widget
      title={rychlaWidgetTitle()}
      collapsable={false}
      className="b2b-RezervaceVytvoreniRychlaWidget"
    >
      <Form
        moduleKey={FORM_REZERVACE_VYTVORENI_MODULE_KEY}
        destroyOnUnmount={false}
        onSubmit={redirectToVytvoreni}
      >
        <FixniPozadavkyBoxErrorContent
          {...fixniPozadavkyBoxError}
          showObdobi={false}
        />
        <RezervaceVytvoreniProjekt />
        <ButtonsSet>
          <ActionButton
            button={Buttons.Primary}
            submit
            validate
            inverse
            disabled={fixniPozadavkyBoxError.isError}
          >
            {rychlaWidgetSubmint()}
          </ActionButton>
        </ButtonsSet>
      </Form>
    </Widget>
  );
}

RezervaceVytvoreniRychlaWidget.propTypes = {};

export default React.memo(RezervaceVytvoreniRychlaWidget);
